<div class="menu-mobile">
    <ul class="menu-mobile__list">
        @for (item of menuData; track $index) {
        @if (item.justMenuMobile && (item?.justRoot ? isRoot : true)) {
        <li class="menu-mobile__item" *showIfAuthorized="item.showIfAuthorizedName">
            <div class="menu-mobile__group-row" (click)="sendRotaLinkMenu(item, $index)">
                <div class="menu-mobile__group-row">
                    <ng-icon class="menu-mobile__icon" [name]="item.icone"></ng-icon>
                    <span class="menu-mobile__txt menu-mobile__txt--bold">
                        {{ item.titulo }}
                    </span>
                </div>

                @if (item.subList && item.subList.length > 0) {
                <ng-icon class="menu-mobile__icon" name="heroChevronDown" size="20px"
                    [ngStyle]="{'transform': item.open ? 'rotate(180deg)' : ''}"></ng-icon>
                }
            </div>

            @if (item.subList && item.open) {
            <ul class="menu-mobile__inline-submenu" @fadeInOut>
                @for (subitem of item.subList; track $index) {
                <li class="menu-mobile__inline-submenu-item"
                    [ngClass]="{'menu-mobile__link--isActive': router.url.includes(subitem.url)}"
                    (click)="sendRotaLinkMenu(subitem, $index)" *showIfAuthorized="subitem.showIfAuthorizedName">
                    <ng-icon [name]="subitem.icone || 'heroMinusSmall'" size="16px"></ng-icon>
                    <span class="text-nowrap">
                        {{ subitem.titulo }}
                    </span>
                </li>
                }
            </ul>
            }
        </li>
        }
        }
    </ul>


    <div class="menu-mobile__perfil">
        <div class="menu-mobile__group-row" (click)="abrirPerfil()">
            <div class="menu-mobile__container-img">
                <img [src]="apiS3.avatarUsuarioLogado" onError="this.src='assets/img/usuarioAnonimo.png';" [title]="''">
            </div>

            <div class="menu-mobile__group">
                <span class="menu-mobile__perfil-txt menu-mobile__txt--bold">
                    {{ sessao?.nome }}
                </span>
                <span class="menu-mobile__txt">
                    {{ sessao?.grupoPermissoesUsuario?.nome || '' }}
                </span>
            </div>
        </div>
        <div class="menu-mobile__btn-logout">
            <button mat-button (click)="sendLogout()">
                <ng-icon name="heroArrowRightStartOnRectangle"></ng-icon>
                Sair
            </button>
        </div>
    </div>

</div>